<template>
    <div v-if="showMedClinicBenefits" role="region" aria-labelledby="my-benefits-heading">
        <hp5-heading element-id="my-benefits-heading" size-selection="lg" tag-selection="h2">My benefits</hp5-heading>
        <hp5-semantic size-selection="sm">
            See what's covered by your plan
        </hp5-semantic>
        <hp5-spacing-vertical xs="xs" xl="xs" md="xs" lg="xs"></hp5-spacing-vertical>
        <div>
            <hp5-semantic size-selection="sm">
                <ul>
                    <li v-for="(benefit, index) in benefitCategories" :key="index">
                        <hp5-link-text-basic :href="buildDetailUrl(benefit.category)" :text="format(benefit.category)" size="sm"></hp5-link-text-basic>
                    </li>
                </ul>
            </hp5-semantic>
        </div>
        <hp5-spacing-vertical xs="md" xl="md" md="md" lg="md"></hp5-spacing-vertical>
    </div>
</template>

<script setup>
const { isAuthenticated, context, benefitCategories } = useFCPModel()

const showMedClinicBenefits = computed(() => isAuthenticated.value && benefitCategories?.value?.length > 0 && context.value.type == 'medical' && !context.value.term)
const { buildUrl } = useUrls(context.value)

const buildDetailUrl = (categoryTerm) => {
    return buildUrl(`/fcp/csearch/benefits/?category=${categoryTerm}`)
}

const format = (name) => {
    const words = name.split(' ')
    let returnString = ''

    words.forEach((w) => {
        returnString += w[0] + w.substr(1).toLowerCase() + ' '
    })
    return returnString
}

</script>